<template>
  <div class="footer">
  <div class="footer-layouts">
    <div class="footer-layouts__tg">
      <a class="footer-layouts__tg-button" :href="'https://t.me/itvibebot'">
        <div class="footer-layouts__tg-button__label">telegram bot</div>
        <img
          class="footer-layouts__tg-button__img"
          src="@/assets/img/start/chevrons-right.svg"
        />
      </a>
    </div>

    <div class="footer-layouts__info">
      <UILogo
        class="footer-layouts-info__logo"
        :logo="require('@/assets/img/IT VIBE.svg')"
        :height="40"
      />
      <UILogotypes :items="getLogotypes()" />
    </div>
  </div>
    <div class="footer-card">
      <p><b>Общество с ограниченной ответственностью «Автоматизированные торговые системы»</b></p>
      <p><b>Адрес:</b> 443086, Самарская область, внутригородской район городского округа Октябрьский, г Самара, ул Скляренко, д. 26, офис 3007 </p>
      <p><b>ИНН:</b> 7706455250</p>
      <p><b>ОКВЭД:</b> 63.11.1 Деятельность по созданию и использованию баз данных и информационных ресурсов</p>
      <p><b>Email:</b> letsgo@itvibe.ru</p>
      <p><b>Телефон:</b> +7 (917) 826 09 88</p>
      <p><b>Виды деятельности в области информационных технологий:</b> 1.01, 1.02</p>
      <div class="footer-card__steck">
        <p><br/>
          Оказание полного цикла услуг по созданию, доработке программных продуктов и развертыванию/поддержке серверной инфраструктуры <br/><br/>
        Frontend: Vue.js, React, JavaScript, TypeScript  <br/>
        Backend: Node.js (NestJS), Python, Java, PHP, .NET, Go  <br/>
        Mobile: iOS (Swift), Android (Kotlin, Java)  <br/>
        Databases: PostgreSQL, MySQL, MongoDB <br/> 
        DevOps: Docker, CI/CD, Git  <br/>
        QA: Manual & Automated Testing (AQA, Java)  <br/>
        Design: Figma  <br/>
        Management: Agile, Scrum, Kanban</p>
      </div>
    </div>    
  </div>

</template>

<script>
import UILogo from '@/components/ui/logo/logo.vue'
import UILogotypes from '@/components/ui/logotypes/logotypes.vue'

export default {
  name: 'FooterLayouts',

  components: {
    UILogo,
    UILogotypes,
  },

  methods: {
    getLogotypes() {
      return [
        {
          id: 0,
          img: require('@/assets/img/footer/email.svg'),
          link: 'letsgo@itvibe.ru',
        },
        {
          id: 2,
          img: require('@/assets/img/footer/telegram.svg'),
          link: 'https://t.me/itvibenews',
        },
        {
          id: 3,
          img: require('@/assets/img/footer/phone_2.svg'),
          link: '+79178260988',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.footer-layouts {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 50px;

  &__tg {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    &-button {
      text-decoration: none;
      display: flex;
      justify-content: center;
      background: black;
      border: 1px solid white;
      border-right: none;
      border-radius: 120px 0 0 120px;
      width: 500px;
      height: 100px;
      transition: transform 1s ease;
      box-shadow: 0px 0px 20px 4px rgba(255, 255, 255, 1);

      &__label {
        display: flex;
        align-items: center;
        line-height: 100%;
        color: white;
        font-size: 26px;
        text-transform: uppercase;
        font-family: 'Montserrat-Light';
      }

      &__img {
        transition: transform 1s ease;
      }

      &:hover {
        transform: scale(1.1);

        .footer-layouts__tg-button__img {
          transform: translateX(60%);
        }
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 5%;
  }
}

.footer-card {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 40px 0 80px;
  & p {
    // font-family: "Arial";
    // font-weight: 400;
    // line-height: 100%;
    font-size: 24px;
    padding: 0 80px;
    margin: 0;
    color: rgba(255, 255, 255, 0.5);

    & b {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

@media screen and (max-width: 760px) {
  .footer-layouts__tg-button {
    border-radius: 0;
    top: 400px;
    width: 100%;
    height: 95px;
    border-left: none;

    &__img {
      display: none;
    }
  }

  .footer-card {
    width: 640px;
    gap: 24px;
    & p {
      font-size: 16px;
      padding: 0 20px;
    }
  }
}

.footer-card__steck p {
  font-size: 12px;
}

@media screen and (max-width: 500px) {
  .footer-card {
    width: 360px;
    gap: 8px;
    & p {
      font-size: 12px;
      padding: 0 auto;
    }
  }
}
</style>
